import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider';
import AxiosClient from '../../assets/AxiosClient';
import FillesRow from './FillesRow';
import ConferenceDropdown from '../../Forms/ConferenceDropdown';
import ToggleSwitch from '../../Models/ToggleSwitch';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Files = () => {
  const { SetNotification } = useStateContext();
  const [files, setFiles] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [filesPerPage] = useState(10); // Set the number of files per page
  const [conferenceId, setConferenceId] = useState(null);
  const [lang, setLang] = useState('English'); // Language filter
  const [isActive, setIsActive] = useState(1); // For active filter (public vs not public)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/public-files');
        const _files = await response.data;
        setFiles(_files);
        setLoading(false);
      } catch (error) {
        SetNotification('Error fetching data', 'danger');
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const filterFiles = () => {
      let filtered = files;

      // Filter by conference
      if (conferenceId) {
        filtered = filtered.filter((file) => file.conference.id === conferenceId);
      }

      // Filter by language
      filtered = filtered.filter((file) => file.lang === lang);

      // Filter by active (public or not public)
      filtered = filtered.filter((file) => file.active == isActive);

      setFilteredFiles(filtered);
    };

    filterFiles();
  }, [files, conferenceId, lang, isActive]); // Added isActive to the dependency array

  // Pagination logic
  const indexOfLastFile = currentPage * filesPerPage;
  const indexOfFirstFile = indexOfLastFile - filesPerPage;
  const currentFiles = filteredFiles.slice(indexOfFirstFile, indexOfLastFile);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <PageHeader
        title="Files"
        description="Manage published event files and language versions."
        actions={(
          <Link className="btn btn-primary" to="./Add">
            <i className="material-icons" aria-hidden="true">add</i>
            Add file
          </Link>
        )}
      />

      <PageToolbar
        filters={(
          <>
            <ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />
            <div className="workspace-filter-group">
              <span className="workspace-filter-group__label">Language</span>
              <div className="workspace-segmented" role="group" aria-label="Filter files by language">
                {['English', 'Arabic'].map((language) => (
                  <button
                    key={language}
                    type="button"
                    className={`btn ${lang === language ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => setLang(language)}
                    aria-pressed={lang === language}
                  >
                    {language}
                  </button>
                ))}
              </div>
            </div>
            <label className="workspace-toggle">
              <span>Public files</span>
              <ToggleSwitch message="" state={isActive} updateIsActive={setIsActive} />
            </label>
          </>
        )}
      />

      {loading ? (
        <div className="workspace-loading"><Loader label="Loading files..." /></div>
      ) : (
        <DataTable>
          <thead>
            <tr>
              <th>Title</th>
              <th>State</th>
              <th>Conference</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentFiles.length > 0 ? (
              currentFiles.map((file) => (
                <FillesRow
                  key={file.id}
                  title={file.title}
                  description={file.description}
                  conference={file.conference}
                  active={file.active}
                  link={file.link}
                  id={file.id}
                />
              ))
            ) : (
              <tr>
                <td colSpan="5" className="workspace-empty">No files available for these filters.</td>
              </tr>
            )}
          </tbody>
        </DataTable>
      )}

      {!loading && filteredFiles.length > filesPerPage && (
        <nav className="workspace-pagination" aria-label="Files pages">
          <ul className="pagination mb-0">
            {Array(Math.ceil(filteredFiles.length / filesPerPage)).fill().map((_, index) => (
              <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => paginate(index + 1)} aria-current={currentPage === index + 1 ? 'page' : undefined}>
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </>
  );
};

export default Files;
